export default {
  'storeOrders.title': 'คำสั่งซื้อร้านค้า',
  'storeOrders.last_three_months': 'ช่วง 3 เดือนที่ผ่านมา',
  'storeOrders.last_six_months': 'ช่วง 6 เดือนที่ผ่านมา',
  'storeOrders.last_one_year': 'ช่วง 1 ปีที่ผ่านมา',
  'storeOrders.filter_state_category.one': 'ตะกร้าสินค้า/ชำระเงิน',
  'storeOrders.filter_state_category.two': 'ชำระเงินแล้ว/ชำระเงินสำเร็จ',
  'storeOrders.filter_state_category.three': 'ยกเลิก/คืนเงินเต็มจำนวน',
  'storeOrders.filter_state_category.four': 'ยกเลิกบางส่วน/คืนเงินบางส่วน',
  'storeOrders.order.no': 'หมายเลขคำสั่งซื้อ',
  'storeOrders.order.amount': 'ยอดรวม',
  'storeOrders.order.status': 'สถานะคำสั่งซื้อ',
  'storeOrders.order.payment_status': 'สถานะการชำระเงิน',
  'storeOrders.order.date': 'วันที่สั่งซื้อ',
  'storeOrders.order.cancel_date': 'วันที่ยกเลิก',
  'storeOrders.order.detail': 'รายละเอียดคำสั่งซื้อ',
  'storeOrders.search_order.placeholder': 'กรุณากรอกหมายเลขคำสั่งซื้อของคุณ',
  'storeOrders.empty': 'ไม่มีข้อมูล',
  'storeOrders.carrier.phone': 'บาร์โค้ดโทรศัพท์มือถือ',
  'storeOrders.carrier.member': 'บาร์โค้ดสมาชิก',
  'storeOrders.carrier.company': 'หมายเลขประจำตัวผู้เสียภาษี',
  'storeOrders.order_info': 'ข้อมูลคำสั่งซื้อ',
  'storeOrders.order_refund_date': 'วันที่คืนเงิน',
  'storeOrders.refund_amount': 'จำนวนเงินที่คืน',
  'storeOrders.credit_card_last_four_digits': 'หมายเลข 4 หลักสุดท้ายของบัตรเครดิต',
  'storeOrders.contact_number': 'หมายเลขติดต่อ',
  'storeOrders.email': 'อีเมล',
  'storeOrders.company_header': 'ชื่อบริษัท / หัวใบกำกับภาษี',
  'storeOrders.order_detail': 'รายละเอียดสินค้า',
  'storeOrders.order_code': 'บาร์โค้ดคำสั่งซื้อ',
  'storeOrders.close': 'ปิด',
  'storeOrders.search_fail': 'ไม่สามารถค้นหาข้อมูลได้',
  'storeOrders.text.research': 'คุณสามารถคลิกที่ปุ่มด้านล่างเพื่อลองค้นหาใหม่อีกครั้ง',
  'storeOrders.retry': 'ลองใหม่',
} as Record<string, string>;
